const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4694 17.7816L36.4441 38.0844C36.4441 38.0844 35.8804 39.4937 34.3302 38.8154L28.4813 34.3304L28.596 34.4202L24.923 37.7761C24.923 37.7761 24.6324 37.9963 24.3241 37.8553L24.5412 35.9362L25.063 31.5223C25.063 31.5223 35.3686 22.2561 35.7913 21.8598C36.2141 21.4722 36.0732 21.3841 36.0732 21.3841C36.1084 20.9085 35.3157 21.3841 35.3157 21.3841L21.6546 30.0599L15.9652 28.1488C15.9652 28.1488 15.0932 27.8405 15.0051 27.1623C14.9171 26.4841 15.9916 26.1229 15.9916 26.1229L38.6109 17.2531C38.6109 17.2443 40.4694 16.4252 40.4694 17.7816Z",
    fill: "#790FFF",
    style: {
      fill: "#790FFF",
      fill: "color(display-p3 0.4745 0.0588 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4694 17.7816L36.4441 38.0844C36.4441 38.0844 35.8804 39.4937 34.3302 38.8154L28.4813 34.3304L28.596 34.4202L24.923 37.7761C24.923 37.7761 24.6324 37.9963 24.3241 37.8553L24.5412 35.9362L25.063 31.5223C25.063 31.5223 35.3686 22.2561 35.7913 21.8598C36.2141 21.4722 36.0732 21.3841 36.0732 21.3841C36.1084 20.9085 35.3157 21.3841 35.3157 21.3841L21.6546 30.0599L15.9652 28.1488C15.9652 28.1488 15.0932 27.8405 15.0051 27.1623C14.9171 26.4841 15.9916 26.1229 15.9916 26.1229L38.6109 17.2531C38.6109 17.2443 40.4694 16.4252 40.4694 17.7816Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.82cb1a114e130392c24e5ed174bd2ae8.svg";
export { ForwardRef as ReactComponent };